import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from './baseQuery';

export const documentsApi = createApi({
    reducerPath: 'documents',
    baseQuery: baseQueryWithReauth,
    tagTypes: ['documents'],
    endpoints: (builder) => ({
        getDocuments: builder.query<null, void>({
            query: (params: any) => ({
                url: 'cdd/documentos',
                params: params
            }),
            providesTags: ['documents'],
            transformResponse: (response: any) => response
        }),
        getEnabledDocs: builder.query<any, void>({
            query: () => ({
                url: 'cdd/tipos-documento'
            }),
            extraOptions: { maxRetries: 3 },
            transformResponse: (response: { data: any }) =>
                response?.data?.map((item: any, index: number) => ({ ...item, id: index + 1 }))
        }),
        uploadDocumentDataForm: builder.mutation<null, any>({
            query: (params: any) => ({
                url: 'cdd/documentos',
                method: 'POST',
                body: params
            }),
            transformResponse: (response: { data: any }) => response?.data
        }),
        completeUploadFile: builder.mutation<null, any>({
            query: (params: any) => ({
                url: `cdd/documentos/${params?.docId}/${params?.uploadId}/completar`,
                method: 'POST'
            })
        }),
        getAllDocumentTypes: builder.query({
            query: () => ({
                url: 'admin/tipos-documento'
            }),
            transformResponse: (response: { data: any }) => response?.data
        }),
        deleteDocumentById: builder.mutation<null, any>({
            query: (params: any) => ({
                url: `cdd/documentos/${params.docId}`,
                method: 'DELETE'
            }),
            invalidatesTags: (_, error) => (error ? [] : ['documents'])
        })
    })
});

export const {
    useGetAllDocumentTypesQuery,
    useGetEnabledDocsQuery,
    useGetDocumentsQuery,
    useLazyGetDocumentsQuery,
    useUploadDocumentDataFormMutation,
    useCompleteUploadFileMutation,
    useDeleteDocumentByIdMutation
} = documentsApi;
